import _ = require('underscore');

import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { changeSubscriptionsFormat } from '../../../actions/spaces/SubscriptionsActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ChangeSubscriptionsFormatEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.SubscriptionChangeFormat,
  translateName: Messages.changeSubscriptionsFormat_action,
  isVisible: (subscriptions: ISubscriptionInfo[]) => FeatureFlags.pdfsubscriptionsSP1Enabled &&
    (FeatureFlags.pdfsubscriptionsUIEnabled || (subscriptions.length > 0 && subscriptions.every(subscription => subscription.attachPdf))),
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {
    return _.any(subscriptions, (subscription) => subscription.canManageSubscription);
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionsFormat(subscriptions)
};
